var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Setup Guide"}},[_c('v-col',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"outlined":"","rounded":"","small":"","color":"secondary","href":"https://shop.selflane.com","target":"_blank"}},[_vm._v("Use Selflane POS")]),_c('OnlineSetup',{staticClass:"my-5"}),_c('URL')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }